import { Component, OnInit, Compiler, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
// import { MdDialogRef, MdDialogConfig } from '@angular/material/core';
import { ViewReportService } from './view-report.service';
import { environment as ENV } from '../../../environments/environment';
import { AddCoapplicantComponent } from '../../admin/add-coapplicant/add-coapplicant.component';
import { AuthService } from 'app/laas/auth.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AddCustomerService } from '../../admin/add-customer.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AdminAuthService } from '../../admin/admin-auth.service';
import * as moment from 'moment';
import { AdminService } from '../../admin/admin.service';
import * as FileSaver from 'file-saver';
// import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
// import { AddCoapplicantComponent} from '../add-coapplicant/add-coapplicant.component'

@Component({
  selector: 'wl-view-report-page',
  templateUrl: './view-report-page.component.html',
  styleUrls: ['./view-report-page.scss'],
  providers: [ViewReportService, AddCustomerService, AdminService]
})
export class ViewReportPageComponent implements OnInit {

  allUsers: Observable<any>;
  isDataPending: boolean;
  search = new UntypedFormControl();
  rocCount: number;
  credCount: number;
  page: number = 1;
  totalPage: number = 1;
  totalCount: number;
  noUserFound: string;
  reportLink: string;
  adminId: any;
  custId: any;
  iscredCount: boolean;
  showOrHide: boolean;
  placeHolder: string;
  searchHolder: string;
  roleId: string;
  role: string;
  limit: number = 10;
  offset: number = 0;

  userName: string;
  display: boolean;
  typeText: string;
  adminForm: UntypedFormGroup;
  type: any;
  bsModalRef: BsModalRef;
  isRetail: boolean;
  makerOnly: boolean = true;
  pageId: any = 1;
  @ViewChild('date1') firstDate: ElementRef;
  selectedDate: string;
  showSelectedDate: boolean;
  currentDate: any;
  startDate: any;
  endDate: any;

 
  constructor(
    // public bsModalRef: BsModalRef,
    private customer: ViewReportService,
    private dialog: MatDialog,
    private auth: AuthService,
    private router: Router,
    private jwt: JwtHelperService,
    private snackbar: MatSnackBar,
    private cust: AdminAuthService,
    private fb: UntypedFormBuilder,
    private adminservice: AdminService,
    private activatedRoute: ActivatedRoute,
    // public modalService: NgbModal
    private modalService: BsModalService
  ) { 
    this.adminForm = this.fb.group({
      custId: ['', Validators.required],
      name: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z ]+')])],
      email: [''],
      mobileNo: [''],
      
      resAdd: [''],
      offAdd: [''],
      resUnitNo: [''],
      offUnitNo: [''],
      employeeName: [''],
      employeeId: ['']
    });
  }


  ngOnInit() {
    this.currentDate = moment().format('YYYY-MM');
    // const token = sessionStorage.getItem('HicFCyC7V0mJYg3Yw2BBOQ');
    var encrypted = sessionStorage.getItem('ubknknsviubi--131ss');
    console.log("decrypted " + JSON.stringify(atob(encrypted)));
    // var jwtObj = this.jwt.decodeToken(token)
    // console.log("jwt token " + JSON.stringify(jwtObj));

    // var roleObj = this.cust.getRole();
    // console.log("roleObj " + JSON.stringify(roleObj))
    // var parsedRole = JSON.parse(roleObj);
    // this.role = roleObj.role;
    this.role = sessionStorage.getItem('wzbvdsjvbbs');
    console.log("role " + this.role);

    if (sessionStorage.getItem('filterDateViewOnline')) {
      this.currentDate = moment(sessionStorage.getItem('filterDateViewOnline'), 'YYYY-MM-DD').format('YYYY-MM');
      let selected = this.currentDate;
      var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      var another = months[+selected.split('-')[1] - 1];
      this.selectedDate = another + ', ' + selected.split('-')[0];
      this.showSelectedDate = true;
    }

    this.roleId = sessionStorage.getItem('getroleId');

    console.log("this.roleId " + this.roleId);

    this.adminId = sessionStorage.getItem('wl-admin-id');
  }

  runReport() {
    console.log(this.startDate, this.endDate)
    let startDate;
    let endDate;
    if(this.startDate && this.startDate.split('-')[0].length>2){
      startDate = this.startDate ? this.startDate.split('-').reverse().join('-') : ""
      endDate = this.endDate ? this.endDate.split('-').reverse().join('-') : ""
    }else{
      startDate = this.startDate ? this.startDate:""
      endDate = this.endDate ? this.endDate:""
    }
    if(this.startDate && this.endDate){
      this.customer.getfreshcasesreport(startDate, endDate).subscribe(resp => {
      console.log(resp)
      if (resp && resp.message && resp.message == "success") {
        if (resp && resp.result) {
          console.log(resp.result, this.base64ToBlob(resp.result))
          /* FileSaver.saveAs(resp.result, `filename.csv`) */
          this.base64ToBlob(resp.result)
          FileSaver.saveAs(this.base64ToBlob(resp.result), "mis-report.csv");
        }

      }
    })
    }else{
      this.snackbar.open('Please enter valid dates','OK',{duration:3000})
    }



  }

  base64ToBlob(b64Data, sliceSize = 512) {
    let byteCharacters = atob(b64Data); //data.file there
    let byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);

      let byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  }

  submitDates() {
    this.showSelectedDate = true;
    console.log(this.firstDate.nativeElement.value);
    let selected = this.firstDate.nativeElement.value;
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    var another = months[+selected.split('-')[1] - 1];
    this.selectedDate = another + ', ' + selected.split('-')[0];
    console.log(this.firstDate.nativeElement.value);
    let filterDate = this.firstDate.nativeElement.value + '-01';
    sessionStorage.setItem('filterDateViewOnline', filterDate);
    let date = new Date(filterDate);
    let dateInMs = date.getTime()
    this.customer.getUsersFilterDate("", this.roleId, 0, 10, dateInMs).subscribe(res => {
      console.log(res);
      if (res && res.result && res.result.resultData) {
        this.allUsers = res.result.resultData ? res.result.resultData : "";
        this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
        this.totalPage = Math.ceil(this.totalCount / 10);
      }
    })
  }


  closeButtonClick() {
    this.selectedDate = "";
    this.showSelectedDate = false;
    sessionStorage.removeItem('filterDateViewOnline');
    this.adminservice.reloadComponent(this.activatedRoute.snapshot['_routerState'].url);
  }


}
